/*
  Line Art çizim posteri stüdyosu — "Line Art Çizim Poster Tablosu", "Annelere Özel…", "Babalara Özel…" (Teeinblue yerine).
  Müşteri fotoğraf yükler → sunucu (/cizim/uret) yapay zekâyla tek kalınlık siyah çizgi çizime çevirir (~10–15 sn) →
  çizim tarayıcıda temizlenir (renk/gri dolgu atılır), kalınlaştırılır ve PSD'deki ("Love Tablo.psd", 3937×5512 = 50×70 cm
  @200 dpi) kemerin içine oturtulur. Başlık (an-ne, ba-ba, lo-ve. …), isteğe bağlı Spotify kodu (şarkı arama) ve hediye polaroid.
  Sepete eklerken poster tam çözünürlükte JPEG olarak çizilir, sunucu 50×70 PDF yapar (/cizim/baski/:id).
  Ortak görünüm müzik posteri stüdyosunun CSS'inden gelir (fso-muzik-poster.css: fso-mp-* sınıfları).
*/
(function () {
  'use strict';
  if (window.FsoCizim) return;

  /* ---------- PSD ölçüleri (px, 3937×5512) ---------- */
  var W = 3937, H = 5512;
  var ZEMIN = '#F3F6F5';
  var KEMER = { x: 399, y: 399, w: 3141, h: 3642 };
  var CIZIM = { x: 819, y: 1170, w: 2300, h: 2120 }; // çizimin sığdırıldığı kutu (kemerin içinde, kodun üstünde)
  var KOD = { x: 1303, y: 3509, w: 1331, h: 224 };
  var METIN_K = { x: 1473, y: 4398, w: 2064, h: 583 };
  var BASLIK = {
    love: { etiket: 'lo-ve.', x: 624, y: 4239, w: 602, h: 828 },
    anne: { etiket: 'an-ne', x: 635, y: 4379, w: 685, h: 688 },
    baba: { etiket: 'ba-ba', x: 648, y: 4223, w: 655, h: 838 },
    aile: { etiket: 'ai-le', x: 646, y: 4267, w: 513, h: 800 },
    family: { etiket: 'fam-ily', x: 585, y: 4390, w: 694, h: 633 },
    mama: { etiket: 'ma-ma', x: 525, y: 4379, w: 816, h: 688 },
    mom: { etiket: 'mom', x: 517, y: 4592, w: 819, h: 213 },
    dad: { etiket: 'dad', x: 601, y: 4500, w: 582, h: 316 },
    arkadas: { etiket: 'arkadaş', x: 484, y: 4344, w: 881, h: 717 },
  };
  // Çizgi kalınlığı: baskıda kalınlaştırma yarıçapı (px). PSD örneğindeki çizgi ~13 px ("orta"ya yakın); "kalın" 5.5'i
  // geçince yüz ayrıntıları (göz, ağız) dolmaya başlıyor
  var KALINLIK = { ince: 1.5, orta: 3.5, kalin: 5.5 };
  var BASKI = [[3937, 5512], [3200, 4480], [2600, 3640]]; // tuval açılamazsa (iOS ~16 MP sınırı) küçült
  var RENKLER = [[/beyaz|white/i, 'beyaz'], [/siyah|black/i, 'siyah'], [/ceviz|walnut/i, 'ceviz'], [/ah[sş]ap|naturel|wood|me[sş]e/i, 'ahsap'], [/alt[ıi]n|gold/i, 'altin']];
  var LINK = /(open\.spotify\.com|spotify:track:|spotify\.link\/|spoti\.fi\/)/i;

  var METIN = {
    fotoBaslik: 'Fotoğrafınız:',
    foto: 'Fotoğraf Yükle',
    fotoAlt: 'Yapay zekâ fotoğrafındaki kişileri çizgi çizime çevirir',
    farkli: 'Farklı Fotoğraf',
    yenidenCiz: 'Yeniden Çiz',
    ciziliyor: 'Çiziminiz hazırlanıyor… (yaklaşık 15 sn)',
    iyilestiriliyor: 'Çiziminiz son kez rötuşlanıyor… (birkaç saniye)',
    hazir: 'Çiziminiz hazır. Beğenmezsen yeniden çizdirebilirsin.',
    cizimHata: 'Çizim şu an yapılamadı, tekrar dene.',
    kalinlik: 'Çizgi kalınlığı',
    ince: 'İnce', orta: 'Orta', kalin: 'Kalın',
    baslik: 'Başlık',
    spotify: 'Şarkı (Spotify kodu için, isteğe bağlı)',
    spotifyOrnek: 'Şarkı ya da sanatçı ara…',
    spotifyYardim: 'Şarkının adını ya da sanatçıyı yaz, listeden seç; Spotify linki yapıştırmak da olur. Seçmezsen kod basılmaz.',
    araYok: 'Bu aramayla şarkı bulunamadı. Farklı yazmayı dene ya da Spotify linkini yapıştır.',
    araHata: 'Arama şu an yapılamadı, biraz sonra tekrar dene.',
    spotifyAraniyor: 'Şarkı aranıyor…',
    spotifyHata: 'Bu linkte bir Spotify şarkısı bulunamadı.',
    araSil: 'Aramayı temizle',
    seciliDegistir: 'Değiştir',
    kod: 'Spotify kodu eklensin',
    polaroid: 'Ürününüzün yanında hediye (küçük) polaroid fotoğrafınız (isteğe bağlı)',
    polaroidAlt: 'Ürünlerimiz size özel kutusunun içinde, yanında küçük bir polaroid fotoğrafla gelir.',
    polaroidSec: 'Polaroid fotoğrafı seç',
    polaroidKaldir: 'Kaldır',
    yerTutucu: 'Fotoğrafını yükle, çizimin burada belirecek',
    kodYerTutucu: 'Spotify kodu (isteğe bağlı)',
    once: 'Önce fotoğrafını yükle; çizimin hazır olunca sepete ekleyebilirsin.',
    bekle: 'Çizimin hazırlanıyor, birkaç saniye bekle.',
    baskiHazirlaniyor: 'Baskı dosyan hazırlanıyor…',
    yukleniyor: 'Yükleniyor',
    baskiHata: 'Baskı dosyası gönderilemedi, lütfen tekrar dene.',
    gorunum: 'Görünüm', gorunumPoster: 'Posterin', gorunumGaleri: 'Ürün fotoğrafları',
    yukari: 'Posterin yukarıda, görmek için dokun',
    kvkk: 'Fotoğrafın yalnızca çizimin ve tablonun hazırlanması için kullanılır.',
    kvkkLink: 'Aydınlatma Metni',
  };
  var SIMGE = {
    yukle: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="8.5" cy="9" r="1.8"/><path d="M21 15l-5-5L5 21"/></svg>',
    yukari: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 19V5"/><path d="M5 12l7-7 7 7"/></svg>',
    ara: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true" focusable="false"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>',
    sil: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    yenile: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 11a8 8 0 1 0-2.3 5.7"/><path d="M20 4v7h-7"/></svg>',
  };

  function el(etiket, sinif, html) { var e = document.createElement(etiket); if (sinif) e.className = sinif; if (html != null) e.innerHTML = html; return e; }
  function kimlik() { return Math.random().toString(36).slice(2, 8); }
  function tuval(w, h) { var c = document.createElement('canvas'); c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h)); return c; }
  function tuvalBlob(c, q) { return new Promise(function (tamam) { c.toBlob(tamam, 'image/jpeg', q); }); }
  function resimYukle(src, cors) {
    return new Promise(function (tamam, red) {
      var img = new Image();
      if (cors) img.crossOrigin = 'anonymous';
      img.onload = function () { tamam(img); };
      img.onerror = function () { red(new Error('görsel açılamadı: ' + src)); };
      img.src = src;
    });
  }

  /* ---------- Çizim işleme ----------
     Yapay zekânın çıktısı: beyaz zemin üzerinde ince siyah çizgi. Model ara sıra kıyafeti/saçı boyuyor (renkli ya da koyu gri
     dolgu; 2026-10-12 denemelerinde aynı fotoğrafta 3 denemenin 2'si). maskeCikar:
     - yalnız koyu ve renksiz pikseller çizgi sayılır (renkli dolgular atılır, kenar çizgileri kalır),
     - geniş koyu dolguların içi boşaltılır (çizgiden kalın her alanın yalnız kenarı kalır),
     - zemin saydam olur, boşluklar kırpılır.
     dolu: çıktı boyalıysa true (stüdyo bir kez kendiliğinden yeniden çizdirir). */
  // İkili maskede r yarıçaplı (kare) aşındırma: içi tamamen dolu noktalar 1. Satır ve sütun önek toplamlarıyla O(n).
  function asindir(B, w, h, r) {
    var Y = new Uint8Array(w * h), S = new Uint8Array(w * h), on = new Int32Array(Math.max(w, h) + 1), x, y, i;
    for (y = 0; y < h; y++) {
      for (x = 0; x < w; x++) on[x + 1] = on[x] + (B[y * w + x] ? 0 : 1);
      for (x = 0; x < w; x++) {
        var a = x - r, b = x + r;
        Y[y * w + x] = a >= 0 && b < w && on[b + 1] - on[a] === 0 ? 1 : 0;
      }
    }
    for (x = 0; x < w; x++) {
      for (y = 0; y < h; y++) on[y + 1] = on[y] + (Y[y * w + x] ? 0 : 1);
      for (y = 0; y < h; y++) {
        var c = y - r, d = y + r;
        S[y * w + x] = c >= 0 && d < h && on[d + 1] - on[c] === 0 ? 1 : 0;
      }
    }
    return S;
  }

  // Boyalı çıktı ölçümü (400 px'lik kopyada; eşikler 2026-10-12 örnekleriyle: temizlerde koyu/renkli < %1, boyalılarda %8–26)
  function doluMu(img) {
    var o = Math.min(1, 400 / Math.max(img.naturalWidth || img.width, img.naturalHeight || img.height));
    var c = tuval((img.naturalWidth || img.width) * o, (img.naturalHeight || img.height) * o);
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(img, 0, 0, c.width, c.height);
    var p = x.getImageData(0, 0, c.width, c.height).data, w = c.width;
    var koyu = 0, renkli = 0, x0 = w, y0 = c.height, x1 = -1, y1 = -1;
    for (var i = 0, n = 0; i < p.length; i += 4, n++) {
      var r = p[i], g = p[i + 1], b = p[i + 2], mx = Math.max(r, g, b), mn = Math.min(r, g, b);
      var lum = 0.299 * r + 0.587 * g + 0.114 * b, doy = mx ? (mx - mn) / mx : 0;
      if (lum > 232 && doy < 0.12) continue; // zemin
      var px = n % w, py = (n / w) | 0;
      if (px < x0) x0 = px; if (px > x1) x1 = px; if (py < y0) y0 = py; if (py > y1) y1 = py;
      if (doy >= 0.25 && lum < 225) renkli++;
      else if (lum < 110) koyu++;
    }
    c.width = c.height = 1;
    if (x1 < 0) return false;
    var alan = (x1 - x0 + 1) * (y1 - y0 + 1);
    return koyu / alan > 0.06 || renkli / alan > 0.03;
  }

  function maskeCikar(img) {
    var c = tuval(img.naturalWidth || img.width, img.naturalHeight || img.height);
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(img, 0, 0);
    var w = c.width, h = c.height;
    var v = x.getImageData(0, 0, w, h), p = v.data;
    var A = new Float32Array(w * h), B = new Uint8Array(w * h);
    for (var i = 0, n = 0; i < p.length; i += 4, n++) {
      var r = p[i], g = p[i + 1], b = p[i + 2];
      var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
      var lum = 0.299 * r + 0.587 * g + 0.114 * b;
      var doy = mx ? (mx - mn) / mx : 0;
      var a = (doy < 0.42 || lum < 70) && lum <= 200 ? Math.max(0, Math.min(1, (225 - lum) / 165)) : 0;
      A[n] = a;
      B[n] = a > 0.25 ? 1 : 0;
    }
    // Dolgu boşaltma: çizgi kalınlığının (~1–3 px) çok üstündeki alanların içi silinir, kenarları kalır
    var ic = asindir(B, w, h, Math.max(3, Math.round(Math.min(w, h) / 340)));
    var x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (n = 0, i = 0; n < A.length; n++, i += 4) {
      var son = ic[n] ? 0 : A[n];
      p[i] = p[i + 1] = p[i + 2] = 0;
      p[i + 3] = Math.round(son * 255);
      if (son > 0.3) {
        var px = n % w, py = (n / w) | 0;
        if (px < x0) x0 = px; if (px > x1) x1 = px; if (py < y0) y0 = py; if (py > y1) y1 = py;
      }
    }
    x.putImageData(v, 0, 0);
    if (x1 < 0) return null;
    var pay = 4;
    x0 = Math.max(0, x0 - pay); y0 = Math.max(0, y0 - pay); x1 = Math.min(w - 1, x1 + pay); y1 = Math.min(h - 1, y1 + pay);
    var k = tuval(x1 - x0 + 1, y1 - y0 + 1);
    k.getContext('2d').drawImage(c, x0, y0, k.width, k.height, 0, 0, k.width, k.height);
    c.width = c.height = 1;
    return k;
  }

  // Maske hedef ölçekte büyütülür, yarıçap r kadar kalınlaştırılır, kenarlar keskinleştirilir.
  // olcek: baskı pikselinin hedef tuvale oranı (önizlemede küçük)
  function cizgiHazirla(maske, olcek, kalinlik) {
    var s = Math.min(CIZIM.w / maske.width, CIZIM.h / maske.height) * olcek;
    var w = Math.max(1, Math.round(maske.width * s)), h = Math.max(1, Math.round(maske.height * s));
    var r = (KALINLIK[kalinlik] || KALINLIK.orta) * olcek;
    var pay = Math.ceil(r) + 2;
    var b = tuval(w + pay * 2, h + pay * 2), bx = b.getContext('2d');
    bx.imageSmoothingEnabled = true;
    bx.imageSmoothingQuality = 'high';
    var adim = r < 0.6 ? 0 : Math.max(8, Math.ceil(r * 3));
    bx.drawImage(maske, pay, pay, w, h);
    for (var i = 0; i < adim; i++) {
      var aci = (i / adim) * Math.PI * 2;
      bx.drawImage(maske, pay + Math.cos(aci) * r, pay + Math.sin(aci) * r, w, h);
      if (r > 3) bx.drawImage(maske, pay + Math.cos(aci) * r * 0.5, pay + Math.sin(aci) * r * 0.5, w, h);
    }
    // Kenar keskinleştirme (yumuşak eşik)
    var v = bx.getImageData(0, 0, b.width, b.height), p = v.data;
    for (var j = 3; j < p.length; j += 4) {
      var a = p[j] / 255;
      a = a <= 0.22 ? 0 : a >= 0.62 ? 1 : (a - 0.22) / 0.4;
      p[j] = Math.round(a * a * (3 - 2 * a) * 255);
    }
    bx.putImageData(v, 0, 0);
    return { tuval: b, pay: pay };
  }

  // Spotify kodu SVG'si → çubuklar + logo yolu (müzik posteriyle aynı)
  async function kodAl(url) {
    var r = await fetch(url);
    if (!r.ok) throw new Error('kod alınamadı');
    var doc = new DOMParser().parseFromString(await r.text(), 'image/svg+xml');
    var cubuklar = Array.prototype.map.call(doc.querySelectorAll('rect'), function (e) {
      return { x: +e.getAttribute('x') || 0, y: +e.getAttribute('y') || 0, w: +e.getAttribute('width') || 0, h: +e.getAttribute('height') || 0, r: +(e.getAttribute('rx') || 0) };
    }).filter(function (c) { return c.w > 0 && c.w < 200; });
    var yol = doc.querySelector('path'), logo = null;
    if (yol) {
      var t = ((yol.parentNode && yol.parentNode.getAttribute && yol.parentNode.getAttribute('transform')) || '').match(/translate\(\s*([\d.-]+)[\s,]+([\d.-]+)/);
      logo = { d: yol.getAttribute('d'), tx: t ? +t[1] : 0, ty: t ? +t[2] : 0 };
    }
    if (!cubuklar.length) throw new Error('kod boş');
    return { cubuklar: cubuklar, logo: logo };
  }

  /* ---------- Poster çizimi ---------- */
  // d: { gorseller, cizgi: {tuval, pay} | null, baslik, kod, kodGoster, mod: 'onizleme' | 'baski', m }
  function posterCiz(cv, d) {
    var ctx = cv.getContext('2d'), k = cv.width / W;
    ctx.save();
    ctx.fillStyle = ZEMIN;
    ctx.fillRect(0, 0, cv.width, cv.height);
    var g = d.gorseller || {};
    if (g.kemer) ctx.drawImage(g.kemer, KEMER.x * k, KEMER.y * k, KEMER.w * k, KEMER.h * k);
    else { ctx.fillStyle = '#DBE6E3'; ctx.fillRect(KEMER.x * k, KEMER.y * k + KEMER.w * k / 2, KEMER.w * k, (KEMER.h - KEMER.w / 2) * k); }
    // Çizim: kutunun ortasına
    if (d.cizgi) {
      var c = d.cizgi.tuval, p = d.cizgi.pay, cw = c.width - p * 2, ch = c.height - p * 2;
      var olc = (cv.width / W) / d.cizgi.olcek; // cizgi tuvali farklı ölçekte hazırlandıysa
      var x = (CIZIM.x + CIZIM.w / 2) * k - (cw * olc) / 2, y = (CIZIM.y + CIZIM.h / 2) * k - (ch * olc) / 2;
      ctx.drawImage(c, x - p * olc, y - p * olc, c.width * olc, c.height * olc);
    } else if (d.mod === 'onizleme') {
      ctx.fillStyle = 'rgba(17,17,17,0.55)';
      ctx.font = '600 ' + Math.round(86 * k) + 'px system-ui, sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(d.yerTutucu || '', (CIZIM.x + CIZIM.w / 2) * k, (CIZIM.y + CIZIM.h / 2) * k);
    }
    // Spotify kodu (vektör; logo + çubuklar 360×60'lık alanda, kutuya oturur)
    if (d.kod && d.kodGoster) {
      var o = (KOD.w / 360) * k;
      ctx.save();
      ctx.translate(KOD.x * k - 20 * o, KOD.y * k - 20 * o);
      ctx.scale(o, o);
      ctx.fillStyle = '#000000';
      d.kod.cubuklar.forEach(function (cb) {
        ctx.beginPath();
        if (ctx.roundRect) ctx.roundRect(cb.x, cb.y, cb.w, cb.h, cb.r); else ctx.rect(cb.x, cb.y, cb.w, cb.h);
        ctx.fill();
      });
      if (d.kod.logo) { ctx.translate(d.kod.logo.tx, d.kod.logo.ty); ctx.fill(new Path2D(d.kod.logo.d)); }
      ctx.restore();
    } else if (d.mod === 'onizleme' && d.kodGoster !== false) {
      ctx.save();
      ctx.setLineDash([22 * k, 16 * k]);
      ctx.strokeStyle = 'rgba(17,17,17,0.3)';
      ctx.lineWidth = 5 * k;
      ctx.strokeRect(KOD.x * k, KOD.y * k, KOD.w * k, KOD.h * k);
      ctx.restore();
      ctx.fillStyle = 'rgba(17,17,17,0.45)';
      ctx.font = '600 ' + Math.round(62 * k) + 'px system-ui, sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(d.kodYerTutucu || '', (KOD.x + KOD.w / 2) * k, (KOD.y + KOD.h / 2) * k);
    }
    var b = BASLIK[d.baslik] || BASLIK.love;
    if (g.basliklar && g.basliklar[d.baslik]) ctx.drawImage(g.basliklar[d.baslik], b.x * k, b.y * k, b.w * k, b.h * k);
    if (g.metin) ctx.drawImage(g.metin, METIN_K.x * k, METIN_K.y * k, METIN_K.w * k, METIN_K.h * k);
    ctx.restore();
  }

  /* ---------- Stüdyo ---------- */
  function Studyo(kok) {
    var ayarEl = kok.querySelector('[data-fso-cizim-ayar]');
    var ayar = {};
    try { ayar = JSON.parse(ayarEl ? ayarEl.textContent : '{}'); } catch (e) { console.warn('[cizim] ayar okunamadı', e); }
    this.kok = kok;
    this.ayar = ayar;
    this.api = String(ayar.api || '').replace(/\/+$/, '');
    this.m = Object.assign({}, METIN, ayar.metinler || {});
    this.form = ayar.form ? document.querySelector(ayar.form) : kok.closest('form');
    this.medya = ayar.medya ? document.querySelector(ayar.medya) : null;
    this.basliklar = (ayar.basliklar || []).filter(function (b) { return BASLIK[b]; });
    if (!this.basliklar.length) this.basliklar = Object.keys(BASLIK);
    this.baslik = BASLIK[ayar.baslik] ? ayar.baslik : this.basliklar[0];
    this.kalinlik = 'orta';
    this.gorseller = { basliklar: {} };
    this.cizim = null; // { id, img, maske }
    this.sarkiBilgi = null;
    this.polaroid = null;
    this.kur();
  }

  Studyo.prototype.kur = function () {
    var s = this, m = this.m, id = kimlik();
    var kart = el('div', 'fso-mp fso-cz');
    var baslikDugmeleri = this.basliklar.map(function (b) {
      return '<label><input type="radio" name="cz-baslik-' + id + '" value="' + b + '"' + (b === s.baslik ? ' checked' : '') + '><span>' + BASLIK[b].etiket + '</span></label>';
    }).join('');
    kart.innerHTML =
      '<div class="fso-mp-foto" data-cz-foto>' +
        '<p class="fso-mp-foto-baslik"><span data-cz-et="fotoBaslik"></span> <span class="fso-mp-zorunlu" aria-hidden="true">*</span></p>' +
        '<label class="fso-mp-yukle" data-cz-yukle><input type="file" accept="image/*" class="fso-mp-dosya" data-cz-dosya>' +
          '<span class="fso-mp-ikon">' + SIMGE.yukle + '</span><span class="fso-mp-yukle-yazi"><strong data-cz-et="foto"></strong><small data-cz-et="fotoAlt"></small></span></label>' +
        '<div class="fso-cz-yuklu" data-cz-yuklu hidden>' +
          '<img class="fso-cz-kucuk" data-cz-kucuk alt="Yüklediğin fotoğraf">' +
          '<div class="fso-cz-yuklu-sag">' +
            '<p class="fso-cz-durum" data-cz-durum role="status" aria-live="polite"></p>' +
            '<div class="fso-cz-eylem">' +
              '<button type="button" class="fso-cz-yeniden" data-cz-yeniden>' + SIMGE.yenile + '<span data-cz-et="yenidenCiz"></span></button>' +
              '<label class="fso-cz-farkli"><input type="file" accept="image/*" class="fso-mp-dosya" data-cz-dosya><span data-cz-et="farkli"></span></label>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="fso-mp-secim" role="radiogroup" data-cz-kalinlik><span class="fso-mp-secim-baslik" data-cz-et="kalinlik"></span>' +
        ['ince', 'orta', 'kalin'].map(function (k) { return '<label><input type="radio" name="cz-kal-' + id + '" value="' + k + '"' + (k === 'orta' ? ' checked' : '') + '><span data-cz-et="' + k + '"></span></label>'; }).join('') +
      '</div>' +
      '<div class="fso-mp-secim fso-cz-basliklar" role="radiogroup" data-cz-baslik><span class="fso-mp-secim-baslik" data-cz-et="baslik"></span>' + baslikDugmeleri + '</div>' +
      '<div class="fso-mp-alan fso-mp-ara-alan" data-cz-ara-alan><label for="cz-ara-' + id + '" data-cz-et="spotify"></label>' +
        '<div class="fso-mp-ara">' + SIMGE.ara +
          '<input id="cz-ara-' + id + '" type="search" enterkeyhint="search" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="cz-sonuc-' + id + '" data-cz-spotify>' +
          '<span class="fso-mp-ara-donen" data-cz-ara-donen hidden></span>' +
          '<button type="button" class="fso-mp-ara-sil" data-cz-ara-sil hidden>' + SIMGE.sil + '</button>' +
        '</div>' +
        '<ul class="fso-mp-sonuclar" id="cz-sonuc-' + id + '" role="listbox" data-cz-sonuclar hidden></ul>' +
      '</div>' +
      '<div class="fso-mp-secili" data-cz-secili hidden><img alt="" data-cz-secili-kapak>' +
        '<span class="fso-mp-secili-yazi"><span class="fso-mp-secili-ad" data-cz-secili-ad></span><span class="fso-mp-secili-alt" data-cz-secili-alt></span></span>' +
        '<button type="button" class="fso-mp-secili-degistir" data-cz-secili-degistir data-cz-et="seciliDegistir"></button></div>' +
      '<p class="fso-mp-yardim" data-cz-spotify-durum aria-live="polite"></p>' +
      '<label class="fso-mp-onay"><input type="checkbox" data-cz-kod checked disabled><span data-cz-et="kod"></span></label>' +
      (this.ayar.polaroid ?
        '<div class="fso-mp-polaroid"><p class="fso-mp-secim-baslik" data-cz-et="polaroid"></p><p class="fso-mp-not" data-cz-et="polaroidAlt"></p>' +
          '<div class="fso-mp-polaroid-satir"><label class="fso-mp-pol-sec"><input type="file" accept="image/*" class="fso-mp-dosya" data-cz-polaroid><span data-cz-polaroid-ad></span></label>' +
          '<button type="button" class="fso-mp-pol-kaldir" data-cz-polaroid-kaldir hidden></button></div></div>' : '') +
      '<div class="fso-mp-slot" data-cz-slot></div>' +
      '<button type="button" class="fso-mp-yukari" data-cz-yukari hidden>' + SIMGE.yukari + '<span data-cz-et="yukari"></span></button>' +
      '<p class="fso-mp-mesaj" data-cz-mesaj role="status" aria-live="polite"></p>' +
      '<p class="fso-mp-not"><span data-cz-et="kvkk"></span>' + (this.ayar.kvkk ? ' <a target="_blank" rel="noopener" data-cz-kvkk></a>' : '') + '</p>';
    this.kok.appendChild(kart);
    this.kart = kart;
    this.$ = function (q) { return kart.querySelector(q); };
    this.$$ = function (q) { return kart.querySelectorAll(q); };
    this.$$('[data-cz-et]').forEach(function (e) { e.textContent = m[e.getAttribute('data-cz-et')] || ''; });
    this.$('[data-cz-spotify]').placeholder = m.spotifyOrnek;
    this.$('[data-cz-spotify-durum]').textContent = m.spotifyYardim;
    var polAd = this.$('[data-cz-polaroid-ad]');
    if (polAd) polAd.textContent = m.polaroidSec;
    var polKaldir = this.$('[data-cz-polaroid-kaldir]');
    if (polKaldir) polKaldir.textContent = m.polaroidKaldir;
    var kvkkA = this.$('[data-cz-kvkk]');
    if (kvkkA) { kvkkA.href = this.ayar.kvkk; kvkkA.textContent = m.kvkkLink; }

    // Sahne: çerçeveli poster önizlemesi (ürün görsellerinin yerinde)
    var sahne = el('div', 'fso-mp-sahne fso-cz-sahne');
    sahne.innerHTML = '<div class="fso-mp-duvar"><div class="fso-mp-cerceve" data-cz-cerceve><canvas class="fso-mp-tuval" data-cz-tuval width="720" height="1008" role="img" aria-label="Poster önizlemesi"></canvas>' +
      '<div class="fso-cz-perde" data-cz-perde hidden><span class="fso-cz-donen"></span><span data-cz-perde-yazi></span></div></div></div>';
    this.sahne = sahne;
    this.tuval = sahne.querySelector('[data-cz-tuval]');
    var gorunumKutu = el('div', 'fso-mp-gorunum');
    gorunumKutu.setAttribute('role', 'group');
    gorunumKutu.setAttribute('aria-label', m.gorunum);
    gorunumKutu.innerHTML = '<button type="button" data-cz-gorunum="poster" aria-pressed="true"></button><button type="button" data-cz-gorunum="galeri" aria-pressed="false"></button>';
    gorunumKutu.querySelector('[data-cz-gorunum="poster"]').textContent = m.gorunumPoster;
    gorunumKutu.querySelector('[data-cz-gorunum="galeri"]').textContent = m.gorunumGaleri;
    gorunumKutu.querySelectorAll('[data-cz-gorunum]').forEach(function (b) { b.addEventListener('click', function () { s.gorunumSec(b.getAttribute('data-cz-gorunum')); }); });
    this.gorunumKutu = gorunumKutu;
    this.gorunum = 'poster';
    this.yerlestir();

    // Olaylar
    this.$$('[data-cz-dosya]').forEach(function (inp) {
      inp.addEventListener('change', function () { if (inp.files && inp.files[0]) s.fotoSec(inp.files[0]); inp.value = ''; });
    });
    this.$('[data-cz-yeniden]').addEventListener('click', function () { if (s.fotoVeri) s.cizimBaslat(); });
    this.$$('[data-cz-kalinlik] input').forEach(function (r) { r.addEventListener('change', function () { s.kalinlik = r.value; s.cizgiOnbellek = {}; s.ciz(); }); });
    this.$$('[data-cz-baslik] input').forEach(function (r) { r.addEventListener('change', function () { s.baslik = r.value; s.ciz(); }); });
    this.$('[data-cz-kod]').addEventListener('change', function () { s.ciz(); });
    this.aramaKur();
    var pol = this.$('[data-cz-polaroid]');
    if (pol) {
      pol.addEventListener('change', function () { if (pol.files && pol.files[0]) s.polaroidSec(pol.files[0]); pol.value = ''; });
      this.$('[data-cz-polaroid-kaldir]').addEventListener('click', function () { s.polaroidSec(null); });
    }
    this.$('[data-cz-yukari]').addEventListener('click', function () { s.gorunumSec('poster'); s.sahne.scrollIntoView({ behavior: 'smooth', block: 'center' }); });

    // Çerçeve rengi (ürünün renk seçimi önizlemedeki çerçeveyi değiştirir)
    this.renkGuncelle();
    document.addEventListener('click', function (e) {
      if (s.ayar.renk && e.target.closest && e.target.closest(s.ayar.renk.replace(/\.selected\b/, ''))) requestAnimationFrame(function () { s.renkGuncelle(); });
    });

    // Sipariş özellikleri + sepete ekleme kapısı
    if (this.form) {
      this.girdiler = {};
      ['_tasarim', '_tasarim_pdf', '_tasarim_onizleme', '_foto', '_cizim', '_baslik', '_cizgi', '_sarki', '_sanatci', '_spotify', '_polaroid'].forEach(function (ad) {
        var g = s.form.querySelector('input[name="properties[' + ad + ']"]');
        if (!g) { g = document.createElement('input'); g.type = 'hidden'; g.name = 'properties[' + ad + ']'; s.form.appendChild(g); }
        g.value = '';
        s.girdiler[ad] = g;
      });
      window.addEventListener('click', function (e) {
        var b = e.target && e.target.closest && e.target.closest('button[type="submit"], input[type="submit"]');
        if (b && b.form === s.form) s.gonderiliyor(e, b);
      }, true);
      window.addEventListener('submit', function (e) { if (e.target === s.form && !s.gecis) s.gonderiliyor(e, null); }, true);
    }

    this.cizgiOnbellek = {};
    this.ciz();
    this.gorselleriYukle();
  };

  Studyo.prototype.gorselleriYukle = function () {
    var s = this, g = this.ayar.gorseller || {}, isler = [];
    if (g.kemer) isler.push(resimYukle(g.kemer).then(function (i) { s.gorseller.kemer = i; }));
    if (g.metin) isler.push(resimYukle(g.metin).then(function (i) { s.gorseller.metin = i; }));
    Object.keys(g.basliklar || {}).forEach(function (b) {
      if (s.basliklar.indexOf(b) < 0) return;
      isler.push(resimYukle(g.basliklar[b]).then(function (i) { s.gorseller.basliklar[b] = i; s.ciz(); }));
    });
    this.gorsellerHazir = Promise.all(isler.map(function (p) { return p.catch(function (e) { console.warn('[cizim]', e); }); })).then(function () { s.ciz(); });
  };

  Studyo.prototype.yerlestir = function () {
    var medyada = !!this.medya;
    if (medyada) {
      if (this.medya.firstElementChild !== this.gorunumKutu) this.medya.insertBefore(this.gorunumKutu, this.medya.firstChild);
      if (this.gorunumKutu.nextElementSibling !== this.sahne) this.gorunumKutu.after(this.sahne);
    } else if (this.sahne.parentNode !== this.$('[data-cz-slot]')) {
      this.$('[data-cz-slot]').appendChild(this.sahne);
    }
    this.galeri = this.ayar.galeri ? document.querySelector(this.ayar.galeri) : null;
    this.gorunumKutu.hidden = !(medyada && this.galeri);
    this.$('[data-cz-yukari]').hidden = !medyada;
    this.gorunumSec(medyada ? this.gorunum : 'poster');
  };

  Studyo.prototype.gorunumSec = function (gorunum) {
    var medyada = !!this.medya && this.sahne.parentNode === this.medya;
    this.gorunum = medyada && this.galeri && gorunum === 'galeri' ? 'galeri' : 'poster';
    var galeride = this.gorunum === 'galeri';
    if (this.galeri) this.galeri.classList.toggle('fso-mp-gizle', medyada && !galeride);
    this.sahne.hidden = galeride;
    this.gorunumKutu.querySelectorAll('[data-cz-gorunum]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-cz-gorunum') === (galeride ? 'galeri' : 'poster')));
    });
  };

  Studyo.prototype.renkGuncelle = function () {
    var secili = this.ayar.renk ? document.querySelector(this.ayar.renk) : null;
    var deger = secili ? (secili.getAttribute('data-value') || secili.textContent || '') : '';
    var ad = 'siyah';
    for (var i = 0; i < RENKLER.length; i++) if (RENKLER[i][0].test(deger)) { ad = RENKLER[i][1]; break; }
    this.sahne.querySelector('[data-cz-cerceve]').setAttribute('data-renk', ad);
  };

  Studyo.prototype.durum = function () {
    var kodVar = !!(this.sarkiBilgi && this.sarkiBilgi.kod);
    return {
      baslik: this.baslik,
      kalinlik: this.kalinlik,
      kod: kodVar ? this.sarkiBilgi.kod : null,
      kodGoster: kodVar ? this.$('[data-cz-kod]').checked : null,
      sarki: this.sarkiBilgi ? this.sarkiBilgi.ad : '',
      sanatci: this.sarkiBilgi ? this.sarkiBilgi.sanatci : '',
      spotify: this.sarkiBilgi ? 'https://open.spotify.com/track/' + this.sarkiBilgi.id : '',
    };
  };

  // Çizgi tuvali ölçeğe göre önbelleğe alınır (kalınlık değişince sıfırlanır)
  Studyo.prototype.cizgi = function (olcek) {
    if (!this.cizim || !this.cizim.maske) return null;
    var anahtar = this.kalinlik + '|' + olcek.toFixed(4);
    if (!this.cizgiOnbellek[anahtar]) {
      var c = cizgiHazirla(this.cizim.maske, olcek, this.kalinlik);
      c.olcek = olcek;
      this.cizgiOnbellek[anahtar] = c;
    }
    return this.cizgiOnbellek[anahtar];
  };

  Studyo.prototype.cizimVerisi = function (d, mod, olcek) {
    return Object.assign({}, d, { mod: mod, gorseller: this.gorseller, cizgi: this.cizgi(olcek), yerTutucu: this.m.yerTutucu, kodYerTutucu: this.m.kodYerTutucu });
  };

  Studyo.prototype.ciz = function () {
    var d = this.durum();
    posterCiz(this.tuval, this.cizimVerisi(d, 'onizleme', this.tuval.width / W));
    if (this.girdiler && this.gonderilen) this.gonderilen = null; // tasarım değişti: sepete eklerken baskı yeniden hazırlanır
  };

  Studyo.prototype.mesaj = function (t, tur) {
    var p = this.$('[data-cz-mesaj]');
    p.textContent = t || '';
    p.classList.toggle('is-error', tur === 'hata');
  };

  Studyo.prototype.perde = function (yazi) {
    var p = this.sahne.querySelector('[data-cz-perde]');
    p.hidden = !yazi;
    p.querySelector('[data-cz-perde-yazi]').textContent = yazi || '';
  };

  /* ---------- Fotoğraf → yapay zekâ çizimi ---------- */
  Studyo.prototype.fotoSec = async function (dosya) {
    if (!dosya || !/^image\//.test(dosya.type || 'image/')) return;
    var url = URL.createObjectURL(dosya);
    try {
      var img = await resimYukle(url);
      // Sunucuya en uzun kenarı 1280 px JPEG (tarayıcı EXIF yönünü uygular)
      var o = Math.min(1, 1280 / Math.max(img.naturalWidth, img.naturalHeight));
      var c = tuval(img.naturalWidth * o, img.naturalHeight * o), x = c.getContext('2d');
      x.fillStyle = '#FFFFFF';
      x.fillRect(0, 0, c.width, c.height);
      x.imageSmoothingQuality = 'high';
      x.drawImage(img, 0, 0, c.width, c.height);
      var oran = c.height / c.width;
      this.fotoVeri = { veri: c.toDataURL('image/jpeg', 0.88), oran: oran > 1.4 ? '2:3' : oran > 1.12 ? '3:4' : oran < 0.71 ? '3:2' : oran < 0.89 ? '4:3' : '1:1' };
      var kucuk = this.$('[data-cz-kucuk]');
      kucuk.src = c.toDataURL('image/jpeg', 0.8);
      c.width = c.height = 1;
    } catch (e) {
      this.mesaj('Fotoğraf açılamadı, başka bir fotoğraf dene.', 'hata');
      return;
    } finally {
      URL.revokeObjectURL(url);
    }
    this.$('[data-cz-yukle]').hidden = true;
    this.$('[data-cz-yuklu]').hidden = false;
    this.mesaj('');
    this.cizimBaslat();
  };

  Studyo.prototype.cizimBaslat = async function (otomatik) {
    var s = this, sira = (this.cizimSira = (this.cizimSira || 0) + 1);
    var durumEl = this.$('[data-cz-durum]');
    this.ciziliyor = true;
    this.cizim = null;
    this.cizgiOnbellek = {};
    this.gonderilen = null;
    this.$('[data-cz-yeniden]').disabled = true;
    durumEl.classList.remove('is-error');
    durumEl.textContent = otomatik ? this.m.iyilestiriliyor : this.m.ciziliyor;
    this.perde(otomatik ? this.m.iyilestiriliyor : this.m.ciziliyor);
    this.ciz();
    if (window.innerWidth < 1025 && this.sahne.getBoundingClientRect().bottom < 0) this.$('[data-cz-yukari]').hidden = false;
    try {
      var r = await this.istek('/cizim/uret', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ foto: this.fotoVeri.veri, oran: this.fotoVeri.oran }) });
      var sonuc = null, bas = Date.now();
      while (Date.now() - bas < 150000) {
        await new Promise(function (t) { setTimeout(t, 2000); });
        if (sira !== this.cizimSira) return;
        var d = await this.istek('/cizim/durum/' + r.id);
        if (d.durum === 'hazir') { sonuc = d; break; }
        if (d.durum === 'hata') { var h = new Error(d.hata || this.m.cizimHata); h.sunucu = true; throw h; }
      }
      if (!sonuc) throw new Error('zaman aşımı');
      var img = await resimYukle(sonuc.cizim, true);
      if (sira !== this.cizimSira) return;
      // Model kıyafeti/saçı boyadıysa bir kez kendiliğinden yeniden çizdir (ikincisi de boyalıysa dolgusu boşaltılmış hâli kullanılır)
      if (doluMu(img) && !otomatik) {
        // Yeni çağrı sıra numarasını artırır; bu çağrının finally bloğu böylece perdeyi kapatmaz
        return this.cizimBaslat(true);
      }
      var maske = maskeCikar(img);
      if (!maske) { var h2 = new Error('Fotoğrafta kişi bulunamadı, başka bir fotoğraf dene.'); h2.sunucu = true; throw h2; }
      this.cizim = { id: r.id, img: img, maske: maske, adres: sonuc.cizim };
      durumEl.textContent = this.m.hazir;
      if (window.innerWidth < 1025) this.gorunumSec('poster');
    } catch (e) {
      if (sira !== this.cizimSira) return;
      console.warn('[cizim]', e);
      durumEl.textContent = e && e.sunucu ? e.message : this.m.cizimHata;
      durumEl.classList.add('is-error');
    } finally {
      if (sira === this.cizimSira) {
        this.ciziliyor = false;
        this.$('[data-cz-yeniden]').disabled = false;
        this.perde(null);
        s.ciz();
      }
    }
  };

  Studyo.prototype.istek = async function (yol, secenek) {
    var r = await fetch(this.api + yol, secenek || {});
    var veri = await r.json().catch(function () { return {}; });
    if (!r.ok) { var h = new Error(veri.hata || this.m.cizimHata); h.sunucu = !!veri.hata; throw h; }
    return veri;
  };

  /* ---------- Şarkı arama (müzik posteriyle aynı davranış) ---------- */
  Studyo.prototype.aramaKur = function () {
    var s = this, girdi = this.$('[data-cz-spotify]'), sil = this.$('[data-cz-ara-sil]'), liste = this.$('[data-cz-sonuclar]'), bekle;
    sil.setAttribute('aria-label', this.m.araSil);
    this.sonuclar = [];
    this.aktif = -1;
    var yaz = function () {
      clearTimeout(bekle);
      s.araSira = (s.araSira || 0) + 1;
      s.araDonuyor(false);
      var v = girdi.value.trim();
      if (!v) { s.sonucKapat(); s.spotifyAl(''); return; }
      if (v === s.araEtiket) return;
      if (LINK.test(v) || /^[A-Za-z0-9]{22}$/.test(v)) { s.sonucKapat(); bekle = setTimeout(function () { s.spotifyAl(v); }, 350); return; }
      bekle = setTimeout(function () { s.sarkiAra(v); }, 320);
    };
    girdi.addEventListener('input', yaz);
    girdi.addEventListener('keydown', function (e) {
      var acik = !liste.hidden && s.sonuclar.length;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!acik) return;
        e.preventDefault();
        s.aktifYap((s.aktif + (e.key === 'ArrowDown' ? 1 : -1) + s.sonuclar.length) % s.sonuclar.length);
      } else if (e.key === 'Enter') {
        e.preventDefault();
        if (acik) s.sarkiSec(s.sonuclar[s.aktif >= 0 ? s.aktif : 0]);
        else { clearTimeout(bekle); var v = girdi.value.trim(); if (v && v !== s.araEtiket) (LINK.test(v) ? s.spotifyAl(v) : s.sarkiAra(v)); }
      } else if (e.key === 'Escape' && acik) {
        e.preventDefault();
        s.sonucKapat();
      }
    });
    girdi.addEventListener('focus', function () { if (s.sonuclar.length && girdi.value.trim() === s.sonAranan) s.sonucGoster(); });
    sil.addEventListener('click', function () { girdi.value = ''; s.araEtiket = null; yaz(); girdi.focus(); });
    liste.addEventListener('mousedown', function (e) { e.preventDefault(); });
    liste.addEventListener('click', function (e) {
      var li = e.target.closest && e.target.closest('[data-i]');
      if (li) s.sarkiSec(s.sonuclar[Number(li.getAttribute('data-i'))]);
    });
    document.addEventListener('pointerdown', function (e) {
      if (!liste.hidden && !(e.target.closest && e.target.closest('[data-cz-ara-alan]') === s.$('[data-cz-ara-alan]'))) s.sonucKapat();
    });
    this.$('[data-cz-secili-degistir]').addEventListener('click', function () { girdi.focus(); girdi.select(); });
  };

  Studyo.prototype.araDonuyor = function (evet) {
    this.$('[data-cz-ara-donen]').hidden = !evet;
    this.$('[data-cz-ara-sil]').hidden = evet || !this.$('[data-cz-spotify]').value.trim();
  };

  Studyo.prototype.sarkiAra = async function (q) {
    var durum = this.$('[data-cz-spotify-durum]');
    if (q.length < 2) { this.sonucKapat(); return; }
    var sira = (this.araSira = (this.araSira || 0) + 1);
    this.araDonuyor(true);
    var r;
    try {
      r = await this.istek('/spotify/ara?q=' + encodeURIComponent(q));
    } catch (e) {
      if (sira !== this.araSira) return;
      this.araDonuyor(false);
      this.sonucKapat();
      durum.textContent = e && e.sunucu ? e.message : this.m.araHata;
      durum.classList.add('is-error');
      return;
    }
    if (sira !== this.araSira) return;
    this.araDonuyor(false);
    this.sonAranan = q;
    this.sonuclar = r.sonuclar || [];
    durum.classList.remove('is-error');
    if (!this.sonuclar.length) { this.sonucKapat(); durum.textContent = this.m.araYok; return; }
    durum.textContent = '';
    var liste = this.$('[data-cz-sonuclar]'), on = liste.id;
    liste.innerHTML = '';
    this.sonuclar.forEach(function (it, i) {
      var li = el('li', 'fso-mp-sonuc');
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');
      li.setAttribute('data-i', String(i));
      li.id = on + '-' + i;
      if (it.kapak) { var img = document.createElement('img'); img.src = it.kapak; img.alt = ''; img.width = 46; img.height = 46; li.appendChild(img); }
      else li.appendChild(el('span', 'fso-mp-sonuc-bos'));
      var yazi = el('span', 'fso-mp-sonuc-yazi');
      var ad = el('span', 'fso-mp-sonuc-ad'); ad.textContent = it.ad;
      var alt = el('span', 'fso-mp-sonuc-alt'); alt.textContent = it.sanatci + (it.yil ? ' · ' + it.yil : '');
      yazi.appendChild(ad); yazi.appendChild(alt); li.appendChild(yazi);
      var sure = el('span', 'fso-mp-sonuc-sure'); sure.textContent = it.sure || ''; li.appendChild(sure);
      liste.appendChild(li);
    });
    this.sonucGoster();
  };

  Studyo.prototype.sonucGoster = function () {
    var liste = this.$('[data-cz-sonuclar]');
    liste.hidden = false;
    liste.scrollTop = 0;
    this.$('[data-cz-spotify]').setAttribute('aria-expanded', 'true');
    this.aktifYap(-1);
  };

  Studyo.prototype.sonucKapat = function () {
    var liste = this.$('[data-cz-sonuclar]'), girdi = this.$('[data-cz-spotify]');
    liste.hidden = true;
    girdi.setAttribute('aria-expanded', 'false');
    girdi.removeAttribute('aria-activedescendant');
    this.aktif = -1;
  };

  Studyo.prototype.aktifYap = function (i) {
    var liste = this.$('[data-cz-sonuclar]'), girdi = this.$('[data-cz-spotify]');
    this.aktif = i;
    Array.prototype.forEach.call(liste.children, function (li, j) {
      li.classList.toggle('is-aktif', j === i);
      li.setAttribute('aria-selected', j === i ? 'true' : 'false');
      if (j === i && li.scrollIntoView) li.scrollIntoView({ block: 'nearest' });
    });
    if (i >= 0) girdi.setAttribute('aria-activedescendant', liste.id + '-' + i); else girdi.removeAttribute('aria-activedescendant');
  };

  Studyo.prototype.sarkiSec = function (it) {
    if (!it) return;
    this.sonucKapat();
    this.araEtiket = it.ad + ' – ' + it.sanatci;
    this.$('[data-cz-spotify]').value = this.araEtiket;
    this.$('[data-cz-ara-sil]').hidden = false;
    this.spotifyAl('spotify:track:' + it.id, it);
  };

  Studyo.prototype.seciliGoster = function (b) {
    var kutu = this.$('[data-cz-secili]');
    if (!b) { kutu.hidden = true; return; }
    var img = this.$('[data-cz-secili-kapak]');
    img.hidden = !b.kapak;
    if (b.kapak) img.src = b.kapak;
    this.$('[data-cz-secili-ad]').textContent = b.ad;
    this.$('[data-cz-secili-alt]').textContent = b.sanatci + (b.sure ? ' · ' + b.sure : '');
    kutu.hidden = false;
  };

  // Link/kimlik → şarkı bilgisi + Spotify kodu (posterde yalnız kod basılır)
  Studyo.prototype.spotifyAl = async function (deger, onBilgi) {
    var v = String(deger || '').trim(), durum = this.$('[data-cz-spotify-durum]'), kodKutu = this.$('[data-cz-kod]');
    if (this.sarkiBilgi && this.sarkiBilgi.girdi === v) return;
    var sira = (this.spotifySira = (this.spotifySira || 0) + 1);
    durum.classList.remove('is-error');
    if (!v) {
      this.sarkiBilgi = null;
      kodKutu.disabled = true;
      this.seciliGoster(null);
      durum.textContent = this.m.spotifyYardim;
      this.ciz();
      return;
    }
    durum.textContent = this.m.spotifyAraniyor;
    this.araDonuyor(true);
    try {
      var b = await this.istek('/spotify?u=' + encodeURIComponent(v) + '&zemin=DBE6E3');
      var kod = await kodAl(b.kod);
      if (sira !== this.spotifySira) return;
      this.sarkiBilgi = { girdi: v, id: b.id, ad: b.ad, sanatci: b.sanatci, kod: kod };
      kodKutu.disabled = false;
      kodKutu.checked = true;
      this.araDonuyor(false);
      this.seciliGoster({ ad: b.ad, sanatci: b.sanatci, sure: b.sure, kapak: b.kapak || (onBilgi && onBilgi.kapak) });
      durum.textContent = '';
      var girdi = this.$('[data-cz-spotify]');
      if (LINK.test(girdi.value) || /^[A-Za-z0-9]{22}$/.test(girdi.value.trim())) { this.araEtiket = b.ad + ' – ' + b.sanatci; girdi.value = this.araEtiket; }
    } catch (e) {
      if (sira !== this.spotifySira) return;
      console.warn('[cizim] spotify', e);
      this.araDonuyor(false);
      this.seciliGoster(null);
      this.sarkiBilgi = null;
      kodKutu.disabled = true;
      durum.textContent = e && e.sunucu ? e.message : this.m.spotifyHata;
      durum.classList.add('is-error');
    }
    this.ciz();
  };

  Studyo.prototype.polaroidSec = function (dosya) {
    this.polaroid = dosya && /^image\//.test(dosya.type || 'image/') ? dosya : null;
    this.$('[data-cz-polaroid-ad]').textContent = this.polaroid ? this.polaroid.name : this.m.polaroidSec;
    this.$('[data-cz-polaroid-kaldir]').hidden = !this.polaroid;
    this.gonderilen = null;
  };

  /* ---------- Sepete ekleme: baskı dosyası ---------- */
  Studyo.prototype.ozellikYaz = function (d, r) {
    var g = this.girdiler, ata = function (ad, v) { if (g[ad]) g[ad].value = v || ''; };
    ata('_tasarim', 'Line Art Poster');
    ata('_tasarim_pdf', r.pdf);
    ata('_tasarim_onizleme', r.onizleme);
    ata('_foto', r.foto);
    ata('_cizim', r.cizim);
    ata('_baslik', BASLIK[d.baslik] ? BASLIK[d.baslik].etiket : d.baslik);
    ata('_cizgi', this.m[d.kalinlik] || d.kalinlik);
    ata('_sarki', d.sarki);
    ata('_sanatci', d.sanatci);
    ata('_spotify', d.spotify ? (d.kodGoster ? d.spotify : d.spotify + ' (kod istenmedi)') : '');
    ata('_polaroid', r.polaroid);
  };

  Studyo.prototype.gonderiliyor = function (e, dugme) {
    if (this.gecis) return;
    var durdur = function () { e.preventDefault(); e.stopImmediatePropagation(); };
    if (this.gonderiyor) { durdur(); return; }
    if (this.ciziliyor) { durdur(); this.mesaj(this.m.bekle, 'hata'); this.goster(); return; }
    if (!this.cizim) { durdur(); this.mesaj(this.m.once, 'hata'); this.goster(); return; }
    var d = this.durum();
    var anahtar = JSON.stringify([d, this.cizim.id, this.polaroid && this.polaroid.size]);
    if (this.gonderilen === anahtar && this.girdiler._tasarim_pdf.value) return; // aynı tasarım zaten hazır
    durdur();
    this.baskiGonder(anahtar, d, dugme || this.form.querySelector('button[type="submit"]'));
  };

  Studyo.prototype.gonder = function (fd, ilerleme) {
    var s = this;
    return new Promise(function (tamam, red) {
      var x = new XMLHttpRequest();
      x.open('POST', s.api + '/cizim/baski/' + s.cizim.id);
      x.responseType = 'json';
      x.upload.onprogress = function (e) { if (e.lengthComputable) ilerleme(e.loaded / e.total); };
      x.onload = function () {
        var v = x.response || {};
        if (x.status >= 200 && x.status < 300 && v.pdf) tamam(v);
        else { var h = new Error(v.hata || s.m.baskiHata); h.sunucu = !!v.hata; red(h); }
      };
      x.onerror = function () { red(new Error(s.m.baskiHata)); };
      x.send(fd);
    });
  };

  Studyo.prototype.baskiGonder = async function (anahtar, d, dugme) {
    var s = this;
    this.gonderiyor = true;
    this.mesaj(this.m.baskiHazirlaniyor);
    if (dugme) { dugme.disabled = true; dugme.setAttribute('aria-busy', 'true'); }
    try {
      await this.gorsellerHazir;
      // 1) Poster tam çözünürlükte (50×70 cm @200 dpi); tuval açılamazsa küçült
      var baski = null;
      for (var i = 0; i < BASKI.length && !baski; i++) {
        var c = tuval(BASKI[i][0], BASKI[i][1]);
        try {
          posterCiz(c, this.cizimVerisi(d, 'baski', c.width / W));
          baski = await tuvalBlob(c, 0.93);
        } catch (e) { baski = null; }
        c.width = c.height = 1;
        this.cizgiOnbellek = {}; // büyük tuvaller bellekte kalmasın
      }
      if (!baski) throw new Error('baskı oluşturulamadı');
      // 2) Sipariş satırı için küçük önizleme
      var k = tuval(600, 840);
      posterCiz(k, this.cizimVerisi(d, 'baski', k.width / W));
      var kucuk = await tuvalBlob(k, 0.85);
      var fd = new FormData();
      fd.append('baski', baski, 'baski.jpg');
      fd.append('onizleme', kucuk, 'onizleme.jpg');
      if (this.polaroid) fd.append('polaroid', this.polaroid, this.polaroid.name || 'polaroid.jpg');
      var r = await this.gonder(fd, function (oran) { s.mesaj(s.m.yukleniyor + ' %' + Math.round(oran * 100)); });
      this.ozellikYaz(d, r);
      this.gonderilen = anahtar;
      this.mesaj('');
      if (dugme) { dugme.disabled = false; dugme.removeAttribute('aria-busy'); }
      this.gecis = true;
      try { if (dugme) dugme.click(); else s.form.requestSubmit(); } finally { this.gecis = false; }
    } catch (e) {
      console.warn('[cizim] baskı', e);
      this.mesaj(e && e.sunucu ? e.message : this.m.baskiHata, 'hata');
      if (dugme) { dugme.disabled = false; dugme.removeAttribute('aria-busy'); }
    } finally {
      this.gonderiyor = false;
      this.ciz();
    }
  };

  Studyo.prototype.goster = function () {
    var kart = this.kok.closest('[data-fso-custom]') || this.kok;
    var ofset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--fso-header-sticky-h'), 10) || 0;
    window.scrollTo({ top: Math.max(0, kart.getBoundingClientRect().top + window.scrollY - ofset - 12), behavior: 'smooth' });
    kart.classList.remove('is-need');
    void kart.offsetWidth;
    kart.classList.add('is-need');
  };

  function baslat() {
    document.querySelectorAll('[data-fso-cizim]').forEach(function (k) {
      if (k.__fsoCizim) return;
      k.__fsoCizim = new Studyo(k);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
  else baslat();
  window.FsoCizim = { baslat: baslat, posterCiz: posterCiz, maskeCikar: maskeCikar, cizgiHazirla: cizgiHazirla, BASLIK: BASLIK };
})();
